import { buildAuthUrl, type SocialProvider } from '@/config/social';

const PROVIDERS: { key: SocialProvider; label: string; bg: string; text: string; border?: string; icon: React.ReactNode }[] = [
  {
    key: 'kakao',
    label: '카카오 로그인',
    bg: 'bg-[#FEE500]',
    text: 'text-black',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
        <path d="M12 3C6.48 3 2 6.58 2 10.94c0 2.73 1.79 5.13 4.49 6.5-.16.58-.57 2.1-.66 2.43-.1.41.15.4.32.29.13-.09 2.09-1.42 2.94-2 .94.14 1.9.22 2.91.22 5.52 0 10-3.58 10-7.94S17.52 3 12 3z" />
      </svg>
    ),
  },
  {
    key: 'naver',
    label: '네이버 로그인',
    bg: 'bg-[#03C75A]',
    text: 'text-white',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
        <path d="M16.27 10.84V3H7.73v7.84L4 3h3.73l4.27 7.84L7.73 3H16.27l-4.27 7.84V21h4.27v-7.84L20.54 21H16.27l-4.27-7.84V21H7.73v-7.84z" />
      </svg>
    ),
  },
  {
    key: 'google',
    label: '구글 로그인',
    bg: 'bg-white',
    text: 'text-gray-700',
    border: 'border border-gray-300',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
      </svg>
    ),
  },
];

export default function SocialLoginButtons() {
  const handleClick = (provider: SocialProvider) => {
    window.location.href = buildAuthUrl(provider);
  };

  return (
    <div className="mt-6">
      <div className="relative mb-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="bg-white px-4 text-gray-400">소셜 계정으로 계속하기</span>
        </div>
      </div>

      <div className="space-y-2.5">
        {PROVIDERS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => handleClick(p.key)}
            className={`flex w-full items-center justify-center gap-2.5 rounded-lg px-4 py-2.5 text-sm font-medium transition-opacity hover:opacity-90 ${p.bg} ${p.text} ${p.border || ''}`}
          >
            {p.icon}
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
